module.exports = __webpack_public_path__ + "/images/agendor-icons.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/agendor-icons.svg?-da6lhh
// module id = 615
// module chunks = 0